<style scoped>
    @import "./index.css";
</style>

<template>
    <div id="layout-container-hui">
        <Row class-name="tf-row">
            <Col :md="8" :xs="24">
                <Card id="myCard" :bordered="false" :dis-hover="true">
                    <div class="myCard-head" slot="title">
                        <span class="myCard-title">意见反馈</span>
                    </div>
                    <div class="myCard-con web-gailan overview">
                        <Form ref="accountLogin" :model="accountLogin" :rules="accountLoginRule" :label-width="80">
                            <FormItem prop="name" label="模块名称">
                                <Input :maxlength="10" clearable placeholder="请输入模块名称" size="large" type="text" v-model="accountLogin.name"></Input>
                            </FormItem>
                            <FormItem prop="con" label="内容">
                                <Input v-model="accountLogin.con" type="textarea" :maxlength="200" :autosize="{minRows: 5,maxRows: 10}" placeholder="请输入您对我们的意见，我们将不断努力改进"></Input>
                            </FormItem>
                            <div style="margin-top: -20px; color:#666; font-size: 14px; text-align: right">
                                {{accountLogin.con.length}}/200
                            </div>
                            <FormItem style="margin-top: 15px">
                                <Button long size="large" :loading="accountLogin.btnLoading" type="primary" @click="handleSubmit('accountLogin')">
                                    <span>{{!accountLogin.btnLoading ? '提交' : '提交中...'}}</span>
                                </Button>
                            </FormItem>
                        </Form>
                    </div>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // +---------------
                // | 输入框数据
                // +---------------
                accountLogin: {
                    name: "",
                    con: "",
                    btnLoading: false,
                },

                // +---------------
                // | 验证规则
                // +---------------
                accountLoginRule: {
                    name: [
                        {required: true, message: "请输入模块名称", trigger: "blur"},
                    ],
                    con: [
                        {required: true, message: "请输入您对我们的意见，我们将不断努力改进", trigger: "blur"},
                    ],
                }
            }
        },
        created() {

        },
        methods: {
            // +---------------
            // | 提交表单
            // +---------------
            handleSubmit(name) {
                const that = this;
                //验证表单
                that.$refs[name].validate(valid => {
                    if (valid)
                    {
                        that.$func.ajax('customerFeedbackSave',
                        {
                            token:that.$func.getToken(),
                            feedbackModule:that[name].name,
                            feedbackContent:that[name].con,
                        },function(r){
                            if(!r.statusCode){
                                that.$func.msg(r.message,'error');
                            }else{
                                that.$func.msg('提交成功！');
                                //按钮状态关闭
                                that[name].btnLoading = false;
                                that.$refs[name].resetFields();
                            }
                        })
                    }
                });
            }
        }
    };
</script>
